export default __webpack_public_path__ + "static/media/jumbo-img-2.bc7b1e77.jpg";